import React, { useState } from 'react';
import css from './BenefitsModal.css';

import ModalPortal from '../../../ModalPortal/ModalPortal';
import Button from '../../../Button/Button';
import { IconCheckCircleL } from '../../../../icons';

export default ({ riderName }) => {
    const [open, setOpen] = useState(false);
    return (
        <>
            <span className={css.pseudoLink} onClick={() => setOpen(true)}>
                Vorteile ansehen
            </span>
            {open && (
                <ModalPortal
                    id="upload-horse-benefits-modal"
                    isOpen
                    onClose={() => setOpen(false)}
                    contentClassName={css.modalContent}
                >
                    <h3 className={css.modalHeading}>Deine Vorteile im Blick</h3>
                    <p className={css.modalDesc}>
                        Erstelle ein kostenloses Pferde-Profil und profitiere von den folgenden Vorteilen:

                    </p>
                    <div className={css.benefitsList}>
                        <p>
                            <IconCheckCircleL />
                            <span>
                                Finde dank Matching heraus, wie gut {riderName} zu deinen Anforderungen
                                passt.
                            </span>
                        </p>
                        <p>
                            <IconCheckCircleL />
                            <span>
                                Erhalte Zugriff auf alle verfügbaren Pferdemenschen in der
                                Datenbank.
                            </span>
                        </p>
                        <p>
                            <IconCheckCircleL />
                            <span>
                                Du kannst ein Pferde-Profil jederzeit 
                                und nach Bedarf pausieren oder reaktivieren.
                            </span>
                        </p>
                    </div>
                    <footer className={css.modalAction}>
                        <Button onClick={() => setOpen(false)}>Schliessen</Button>
                    </footer>
                </ModalPortal>
            )}
        </>
    );
};
